import _createClass from "/codebuild/output/src2543350332/src/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/codebuild/output/src2543350332/src/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/codebuild/output/src2543350332/src/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/codebuild/output/src2543350332/src/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/codebuild/output/src2543350332/src/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
export var BsPrefixComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(BsPrefixComponent, _React$Component);

  var _super = _createSuper(BsPrefixComponent);

  function BsPrefixComponent() {
    _classCallCheck(this, BsPrefixComponent);

    return _super.apply(this, arguments);
  }

  return _createClass(BsPrefixComponent);
}(React.Component); // Need to use this instead of typeof Component to get proper type checking.

export function getOverlayDirection(placement, isRTL) {
  var bsDirection = placement;

  if (placement === 'left') {
    bsDirection = isRTL ? 'end' : 'start';
  } else if (placement === 'right') {
    bsDirection = isRTL ? 'start' : 'end';
  }

  return bsDirection;
}